// src/Pages/Portfolio.js
import Footer from "../Components/Footer";
import Navbar from "../Components/NavBar";
import PortfolioGallery from "../Components/PortfolioGallery";
import { Helmet } from 'react-helmet';

export default function Portfolio() {
    return (
        <>
            <Helmet>
                <title>Design Portfolio - Anita.NG</title>
                <meta name="description" content="Explore our creative design portfolio featuring brand identity, web design, print materials, and social media graphics." />
                <meta name="keywords" content="Graphic design Nigeria, Brand identity design, Web design Lagos, UI/UX design, Print design services, Social media graphics, Creative design portfolio" />
            </Helmet>
            <Navbar />
            <div className="pt-20">
                <PortfolioGallery />
                <DesignProcess />
            </div>
            <Footer />
        </>
    );
}

function DesignProcess() {
    const steps = [
        {
            name: 'Discovery',
            description: 'Understanding your vision, goals, and target audience through detailed consultation.',
            icon: '🔍',
        },
        {
            name: 'Concept Development',
            description: 'Creating initial concepts and exploring different creative directions.',
            icon: '💡',
        },
        {
            name: 'Design Refinement',
            description: 'Perfecting the chosen concept with your feedback and professional expertise.',
            icon: '✨',
        },
        {
            name: 'Final Delivery',
            description: 'Providing all necessary files and formats for your complete design package.',
            icon: '🎯',
        },
    ];

    return (
        <div className="bg-gradient-to-r from-indigo-50 to-purple-50 py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-2xl text-center">
                    <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Our Design Process</h2>
                    <p className="mt-6 text-lg leading-8 text-gray-600">
                        From concept to creation, we follow a proven process to deliver exceptional design solutions.
                    </p>
                </div>
                <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
                    <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-4">
                        {steps.map((step) => (
                            <div key={step.name} className="flex flex-col items-center text-center">
                                <dt className="text-4xl mb-4">{step.icon}</dt>
                                <dd className="text-base font-semibold leading-7 text-gray-900">
                                    {step.name}
                                </dd>
                                <dd className="mt-2 text-base leading-7 text-gray-600">
                                    {step.description}
                                </dd>
                            </div>
                        ))}
                    </dl>
                </div>
            </div>
        </div>
    );
}